import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import md5 from 'js-md5';
import arrow from '@/assets/arrow.png';
import tel from '@/assets/tel.png';
import position from '@/assets/position.png';
import time from '@/assets/time.png';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import './index.scss';

function ShopIntroduce(props: any) {
    const { mark, shopInfo, mallTest } = props;

    const clickTel = () => {
        // 点击埋点
        let extendParams = {
            ...dd.ep,
            providerId: shopInfo.providerId,
            mallTest
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
            'click',
            'ec_topic_mall_jieshao_phone_click',
            dd.baseParams,
            extendParams
        );
    };

    useEffect(() => {
        if (!!shopInfo.shopServiceTelphone && mark.id === 'introduction') {
            // 曝光埋点
            let extendParams = {
                ...dd.ep,
                providerId: shopInfo.providerId,
                mallTest
            };
            extendParams = utils.formatParams(extendParams);
            utils.pvTrackLogger(
                'show',
                'ec_topic_mall_jieshao_phone_show',
                dd.baseParams,
                extendParams
            );
        }
    }, [JSON.stringify(shopInfo), JSON.stringify(mark)]);

    return (
      <div className="shopIntroduce">
        <span className="si-content">
          <span className="si-itemWrap">
            <span className="si-left">
              <img src={tel} />
              <span className="si-title">商家电话</span>
            </span>
            <a
              className="si-right"
              href={
                shopInfo.shopServiceTelphone
                  ? `tel:${shopInfo.shopServiceTelphone}`
                  : undefined
              }
              onClick={() => clickTel()}
            >
              <span className="si-info">
                {shopInfo.shopServiceTelphone || "暂无信息"}
              </span>
              {shopInfo.shopServiceTelphone && (
                <img className="si-icon" src={arrow} />
              )}
            </a>
          </span>
          <span className="si-itemWrap">
            <span className="si-left">
              <img src={position} />
              <span className="si-title">店铺地址</span>
            </span>
            <span className="si-right">
              <span className="si-info">{shopInfo.address || "暂无信息"}</span>
              <span className="si-icon" />
            </span>
          </span>
          <span className="si-itemWrap">
            <span className="si-left">
              <img src={time} />
              <span className="si-title">开店时间</span>
            </span>
            <span className="si-right">
              <span className="si-info">
                {shopInfo.shopRegisterTime || "暂无信息"}
              </span>
              <span className="si-icon" />
            </span>
          </span>
        </span>
      </div>
    );
}

export default ShopIntroduce;
